import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppService } from '../services/app.service';

enum PublicRoutes {
  LOGIN = 'login',
  REGISTER = 'register',
  REVIEW = 'review',
  RESET_PASSWORD = 'reset-password/:token',
  FORGOT_PASSWORD = 'forgot-password'
}

export const authGuard: CanActivateFn = (route, state) => {
  const appService = inject(AppService);
  const router = inject(Router);
  const isLoggedIn = appService.isUserLoggedIn();
  const path = route.routeConfig?.path;

  // Check for public routes when user is already logged in
  const isPublicRoute = [
    PublicRoutes.LOGIN,
    PublicRoutes.REGISTER,
    PublicRoutes.REVIEW,
    PublicRoutes.FORGOT_PASSWORD,
    PublicRoutes.RESET_PASSWORD
  ].includes(path as PublicRoutes);
  const isProtectedRoute = !isPublicRoute;

  const handleRedirect = () => {
    const role = appService.userRole();
    if (['admin', 'user'].includes(role))
      router.navigate(['/jobs'])
    else
      router.navigate(['/users'])
  }

  // Redirect logged-in users from public routes
  if (isPublicRoute && isLoggedIn) {
    handleRedirect();
    return false;
  }

  // Require authentication for non-public routes
  if (isProtectedRoute && !isLoggedIn) {
    router.navigate(['/login']);
    return false;
  }

  return true;
};
